import '../common/base';
import Vue from '../vue/common/vue-common';
import ContactUs from '../vue/components/contact-us/ContactUs.vue';

cr$.ready(function () {
    new Vue(ContactUs);
});
